<template>
    <FormulateForm
        class="avvakta-operation"
        v-model="formData"
        :errors="inputErrors"
        @submit="submit"
        autocomplete="off"
    >
        <div class="patient-dialog-container">
            <DialogAktivPatient :patient="patient" />

            <DialogAnmalaninfo :anmalaninfo="anmalaninfo" />
        </div>

        <div class="form">
            <FormulateInput
                type="vueselect"
                :options="[
                    { value: 'pvv', label: 'Patientvald väntan' },
                    { value: 'mov', label: 'Medicinsk väntan' },
                    { value: 'sov', label: 'Administrativ väntan' },
                ]"
                @input="hanteraUndantagskod"
                name="undantagskod"
                label="Orsak till avvaktan *"
            />

            <FormulateInput type="textarea" label="Kommentar" name="undantagskommentar" />
        </div>

        <ButtonGroup>
            <Button size="primary" type="submit">{{ avvaktaOperationText }}</Button>
            <Button size="secondary" variant="contour" type="button" @click="cancel()">Avbryt</Button>
        </ButtonGroup>
    </FormulateForm>
</template>

<script>
    import dialogEvents from "@/dialogEvents";
    import { mapActions, mapGetters } from "vuex";
    import Button from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import DialogAktivPatient from "@/tabs/Operation/DialogAktivPatient.vue";
    import DialogAnmalaninfo from "@/tabs/Operation/DialogAnmalaninfo.vue";
    import { getErrorMessage } from "@/api";
    import { openDialog } from "@/utils";

    export default {
        name: "AvvaktaOperation",
        components: {
            Button,
            ButtonGroup,
            DialogAktivPatient,
            DialogAnmalaninfo,
        },
        data() {
            return {
                params: this.$attrs.response,
                patient: {},
                anmalaninfo: {
                    datum: "",
                    tid: "",
                    huvudoperator: "",
                    huvudoperationskod: "",
                },
                formData: {
                    undantagskod: null,
                    undantagskommentar: "",
                },
                inputErrors: {},
            };
        },
        computed: {
            ...mapGetters("userData", ["currentProfile"]),
            avvaktaOperationText() {
                return this.$attrs.response.listItem.undantagskod ? "Spara" : "Avvakta operation";
            },
        },
        methods: {
            ...mapActions("operation/operationsanmalan", ["avvaktaOperationAnmalan"]),
            hanteraUndantagskod(value) {
                if (value) {
                    this.inputErrors = {};
                }
            },
            cancel() {
                dialogEvents.$emit("closePopup");
            },
            async submit() {
                try {
                    const payload = {
                        id: this.params.listItem.id,
                        undantagskod: this.formData.undantagskod,
                        undantagskommentar: this.formData.undantagskommentar,
                    };

                    await this.avvaktaOperationAnmalan(payload);

                    this.cancel();
                } catch (error) {
                    if (typeof error.response.data === "object") {
                        const errorMessage = getErrorMessage(error).replace("undantagskod: ", ""); // Formatera `error-meddelande` för undantagskod,

                        this.inputErrors = {
                            undantagskod: [errorMessage],
                        };
                    } else {
                        openDialog("Kunde inte avvakta operationen. ", "error");
                    }
                }
            },
        },

        async created() {
            const itemData = this.propsData?.listItem ?? this.$attrs.response.listItem;

            this.patient = { ...itemData.patient_display };
            this.anmalaninfo.datum = itemData.current_bokad_operation_datum;
            this.anmalaninfo.tid = itemData.current_bokad_operation_tid;
            this.anmalaninfo.huvudoperator = itemData.current_bokad_huvudoperator_display.user_display.name;
            this.anmalaninfo.huvudoperationskod = `${itemData.huvudoperationskod_display.code} ${itemData.huvudoperationskod_display.klassdel_display} ${itemData.huvudoperationskod_display.displayName}`;

            this.formData.undantagskod = itemData.undantagskod;
            this.formData.undantagskommentar = itemData.undantagskommentar;
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/style/modal.scss";

    .avvakta-operation {
        display: flex;
        flex-direction: column;
        gap: 25px;
        width: inherit;
        padding: inherit;
        padding-bottom: 0px;
        padding-top: 0px;

        .patient-dialog-container {
            padding: 0px 50px;
            display: grid;
            gap: 20px;
        }

        .form {
            display: flex;
            flex-direction: column;
            gap: 15px;
            padding: $dialog_box_padding;
        }

        ::v-deep(.button-group) {
            margin: 0px;
            padding: 0px 50px;
        }
    }
</style>
